import * as authDialogActionsImport from '@appActions/dialogs/auth-code/auth-code-dialog.actions';
import * as availabilityActionsImport from '@appActions/dialogs/availability-letter/availability-letter-dialog.actions';

export const authDialogActions = authDialogActionsImport;
export const availabilityActions = availabilityActionsImport;
